import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const GlobalLayout = ({ children }) => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>
          AEPL | AI Training Intelligence for Aviation, Defence &amp; Energy
        </title>
        <meta
          name="description"
          content="Trusted by Etihad Airways, Indigo, Alstom, Indian Navy, CAE, and the world's safest airline — AEPL's AI-powered training platform closes competency gaps in mission-critical industries."
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Anugraha Exceed Pvt Ltd" />
        <html lang="en" />
      </Helmet>
      <div className="min-h-screen flex flex-col bg-background text-white font-sans selection:bg-cyan selection:text-background relative">
        {/* Glow effect */}
        <div className="fixed top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-cyan opacity-0 blur-[100px] pointer-events-none"></div>

        {children}
      </div>
    </HelmetProvider>
  );
};

export default GlobalLayout;
